import React from 'react';

import {
  SYSTEM_MANAGEMENT_MENU_GROUPS,
  getSystemManagementSectionPath,
} from '../routes/systemManagementNavigation.js';

const SystemManagementSidebar = ({
  collapsed = false,
  currentGroup,
  currentSection,
  onNavigate,
  onToggle,
}) => (
  <aside className={`system-management-sidebar ${collapsed ? 'is-collapsed' : ''}`}>
    <header className="sidebar-heading">
      <div className="sidebar-title">系统管理</div>
      <button
        type="button"
        className="sidebar-toggle"
        onClick={onToggle}
        aria-expanded={!collapsed}
        aria-label={collapsed ? '展开系统管理导航' : '收起系统管理导航'}
        title={collapsed ? '展开系统管理导航' : '收起系统管理导航'}
      >
        <i className={`bi bi-chevron-${collapsed ? 'right' : 'left'}`} />
      </button>
    </header>
    {SYSTEM_MANAGEMENT_MENU_GROUPS.map((group) => (
      <div className="sidebar-group" key={group.group}>
        <div className="sidebar-group-title">{group.title}</div>
        {group.items.map((item) => (
          <button
            type="button"
            key={`${group.group}-${item.section}`}
            className={`sidebar-item ${
              currentGroup === group.group && currentSection === item.section
                ? 'active'
                : ''
            }`}
            onClick={() =>
              onNavigate(getSystemManagementSectionPath(item.section, group.group))
            }
          >
            <i className={`bi ${item.icon}`} />
            <span className="sidebar-item-label">{item.label}</span>
          </button>
        ))}
      </div>
    ))}
  </aside>
);

export default SystemManagementSidebar;
